import React, { useCallback, useMemo, useState } from 'react';
import { styled } from '@mui/material';
import { Link } from 'react-router-dom';
import LayoutContext, { LayoutContextType } from 'context/LayoutContext';
import { MinimalProps } from './Minimal.props';
import { classes, StyledLayoutContextProvider } from './Minimal.styles';
import { Logo } from '../../components';


const Minimal = (props: MinimalProps) => {
  const { children } = props;

  const [showPageForm, setShowPageForm] = useState(false);

  const togglePageForm = useCallback(() => setShowPageForm(!showPageForm), [showPageForm]);

  const layoutContextProviderValue = useMemo(
    () => ({ showPageForm, setShowPageForm, togglePageForm }) as LayoutContextType,
    [showPageForm, setShowPageForm, togglePageForm]
  );

  return (
    <StyledLayoutContextProvider value={layoutContextProviderValue}>
      <div className={classes.root}>
        <header className={classes.header}>
          <Link to="/">
            <Logo />
          </Link>
        </header>
        <main className={classes.main}>{children}</main>
      </div>
    </StyledLayoutContextProvider>
  );
};

export default Minimal;
